<template>
  <teleport to="body">
    <div class="dialog">
      <slot />
    </div>
  </teleport>
</template>

<script lang="ts">
import { defineComponent, onUnmounted } from "vue";

const props = {
  active: {
    type: Boolean,
    required: true,
    default: false
  }
};

function changeFilter(value: string) {
  const app = document.getElementById("app");
  if (app) {
    app.style.filter = value;
  } else {
    throw new Error("#app doesn't exist.");
  }
}

function setup() {
  changeFilter("blur(4px);");

  onUnmounted(() => {
    changeFilter("");
  });
}

const Dialog = defineComponent({
  name: "Dialog",
  props,
  setup
});

export default Dialog;
</script>

<style lang="scss">
.dialog {
  overflow-y: scroll;
  z-index: 101;
  background-color: white;
  width: 90vw;
  height: 80vh;
  position: fixed;
  top: 10vh;
  left: 5vw;
  border-radius: 20px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
}
</style>
